import React, { useEffect, useState } from 'react';
import {
  Modal,
  Input,
  InputTextArea,
  Collapse,
  Space,
  Button,
  CheckBox,
  Form,
  Loader,
  openNotification,
  Select,
} from 'tt-ui-lib/core';
import { AddIcon, RightIcon, ArrowReloadIcon, LitterBinIcon } from 'tt-ui-lib/icons';
import styles from '../Modals.module.scss';
import axios from 'axios';
import { v1 as uuidv1 } from 'uuid';
import {
  getTemplateFileUploadLink,
  saveTemplate,
  updateTemplate,
  fetchTemplate,
  deleteTemplate,
  previewTemplate,
  sendTemplateApi,
} from 'api/admin/endpoints/mailing';
import { imageFileTypes } from 'constants/addPost';
import { openHTMLInNewTab } from 'utils/appUtils';

const ExpandIcon = ({ isActive }) => (
  <RightIcon
    style={{
      display: 'block',
      marginTop: 10,
      width: 20,
      height: 20,
      transform: `rotate(${isActive ? 90 : 0}deg)`,
    }}
  />
);

const TemplateModal = ({ open, setOpen, onUpdate, isEdit = false, editId = undefined }) => {
  const [form] = Form.useForm();
  const [sendMailForm] = Form.useForm();

  const [editData, setEditData] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [sendMailModalOpen, setSendMailModalOpen] = useState(false);
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [settings, setSettings] = useState({
    footer_social_instagram: '0',
    footer_social_facebook: '0',
    footer_social_twitter: '0',
    footer_social_linkedin: '0',
    footer_link_contact_us: '0',
    footer_link_about: '0',
    footer_link_how_does_it_work: '0',
    footer_link_q_a: '0',
    footer_link_privacy_policy: '0',
    footer_link_honor_guidelines: '0',
    footer_link_unsubscribe: '0',
    header_logo_custom: '1',
    header_logo_default: '0',
  });
  const [image, setImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);

  const footerSettings = [
    {
      key: '1',
      label: <span style={{ fontWeight: 500 }}>Social networks</span>,
      children: (
        <Space>
          <CheckBox
            label="Instagram"
            value={settings.footer_social_instagram === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_social_instagram: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Facebook"
            value={settings.footer_social_facebook === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_social_facebook: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Twitter"
            value={settings.footer_social_twitter === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_social_twitter: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="LinkedIn"
            value={settings.footer_social_linkedin === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_social_linkedin: value.target.checked ? '1' : '0',
              }))
            }
          />
        </Space>
      ),
    },
    {
      key: '2',
      label: <span style={{ fontWeight: 500 }}>Section</span>,
      children: (
        <Space style={{ flexWrap: 'wrap' }}>
          <CheckBox
            label="Unsubscribe"
            value={settings.footer_link_unsubscribe === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_unsubscribe: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="About"
            value={settings.footer_link_about === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_about: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="How does it work"
            value={settings.footer_link_how_does_it_work === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_how_does_it_work: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Q&A"
            value={settings.footer_link_q_a === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_q_a: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Privacy policy"
            value={settings.footer_link_privacy_policy === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_privacy_policy: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Honor Guidelines"
            value={settings.footer_link_honor_guidelines === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_honor_guidelines: value.target.checked ? '1' : '0',
              }))
            }
          />
          <CheckBox
            label="Contact us"
            value={settings.footer_link_contact_us === '1'}
            onChange={(value) =>
              setSettings((prevValue) => ({
                ...prevValue,
                footer_link_contact_us: value.target.checked ? '1' : '0',
              }))
            }
          />
        </Space>
      ),
    },
  ];

  const closeModal = () => {
    setOpen(false);
    setImage('');
    setImageFile(null);
    form.resetFields();
    sendMailForm.resetFields();

    setSettings({
      footer_social_instagram: '0',
      footer_social_facebook: '0',
      footer_social_twitter: '0',
      footer_social_linkedin: '0',
      footer_link_contact_us: '0',
      footer_link_about: '0',
      footer_link_how_does_it_work: '0',
      footer_link_q_a: '0',
      footer_link_privacy_policy: '0',
      footer_link_honor_guidelines: '0',
      footer_link_unsubscribe: '0',
      header_logo_custom: '1',
    });
    setEditData(null);
  };

  const handleSaveTemplate = (values) => {
    setLoading(true);

    const data = {
      name: values.name,
      subject: values.subject,
      body: values.body,
      platform: values.platform,
      note: values.note || '',
      settings: {
        ...settings,
        footer_text: values.footer_text || '',
        header_logo_text: image?.uuid || '',
        header_logo_desktop: settings.header_logo_custom === '1' ? image?.uuid || '' : '',
        header_logo_mobile: settings.header_logo_custom === '1' ? image?.uuid || '' : '',
      },
      type: 'system',
    };

    saveTemplate(data)
      .then(() => {
        openNotification({
          type: 'success',
          message: 'Template created successfully',
        });
        setLoading(false);
        closeModal();
        if (onUpdate) onUpdate();
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to create template',
        });
        setLoading(false);
      });
  };

  const handleUpdateTemplate = (values) => {
    setLoading(true);

    const data = {
      id: editData?.id || undefined,
      name: values.name,
      subject: values.subject,
      body: values.body,
      platform: values.platform,
      note: values.note || '',
      settings: {
        ...settings,
        footer_text: values.footer_text || '',
        header_logo_text: image?.uuid || '',
        header_logo_desktop: settings.header_logo_custom === '1' ? image?.uuid || '' : '',
        header_logo_mobile: settings.header_logo_custom === '1' ? image?.uuid || '' : '',
      },
      type: 'system',
    };

    updateTemplate(editId, data)
      .then(() => {
        openNotification({
          type: 'success',
          message: 'Template updated successfully',
        });
        setLoading(false);
        closeModal();
        if (onUpdate) onUpdate();
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to update template',
        });
        setLoading(false);
      });
  };

  const submit = (values) => {
    if (isEdit) {
      handleUpdateTemplate(values);
    } else {
      handleSaveTemplate(values);
    }
  };

  const handleDeleteTemplate = () => {
    setDeleteLoading(true);

    deleteTemplate(editId)
      .then(() => {
        setDeleteModalOpen(false);
        setDeleteLoading(false);
        closeModal();
        if (onUpdate) onUpdate();
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to delete template',
        });
        setDeleteLoading(false);
      });
  };

  const openPreview = () => {
    setPreviewLoading(true);

    previewTemplate(editId)
      .then((res) => {
        openHTMLInNewTab(res.data);
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to preview template',
        });
      })
      .finally(() => {
        setPreviewLoading(false);
      });
  };

  const sendTemplate = () => {
    setSendMailModalOpen(true);
  };

  const handleSendMail = async (values) => {
    setSendMailLoading(true);

    const formData = new FormData();
    formData.append('to', values.to);
    formData.append('id', editId);
    formData.append('name', editData?.name || '');

    // Динамически добавляем все поля data[key] из формы, кроме 'to'
    Object.keys(values).forEach((key) => {
      if (key !== 'to') {
        formData.append(`data[${key}]`, values[key]);
      }
    });

    try {
      await sendTemplateApi(formData);

      openNotification({
        type: 'success',
        message: 'Email sent successfully',
      });
      setSendMailModalOpen(false);
    } catch (error) {
      openNotification({
        type: 'error',
        message: 'Failed to send email',
      });
    } finally {
      setSendMailLoading(false);
    }
  };

  const uploadImage = (file) => {
    setImageFile(file);
    setImageLoading(true);

    const fileName = `${uuidv1()}.png`;
    const fileType = 'image';

    getTemplateFileUploadLink(fileName)
      .then((response) => {
        const urlToUpload = response.data?.data?.url;

        if (urlToUpload) {
          axios
            .put(urlToUpload, file, {
              headers: {
                'Content-type': file.type,
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((uploadResponse) => {
              if (uploadResponse.statusText === 'OK') {
                const updatedFile = {
                  file: file,
                  uuid: fileName,
                  url: `${'https://'}${response.data?.data?.download_url}`,
                  loading: false,
                  fileType: fileType,
                  preview: URL.createObjectURL(file),
                };

                setImage(updatedFile);
                setImageLoading(false);
                setImageFile(null);
              }
            })
            .catch(() => {
              setImageLoading(false);
            });
        } else {
          setImageLoading(false);
        }
      })
      .catch(() => {
        setImageLoading(false);
      });
  };

  const getEditData = () => {
    setEditLoading(true);

    fetchTemplate(editId)
      .then((res) => {
        const rawData = res.data?.data;
        const data = {
          ...rawData,
          settings: rawData.settings.reduce(
            (acc, item) => ({
              ...acc,
              [item.key]: item.value,
            }),
            {}
          ),
        };

        setEditData(data);
        setImage({
          url: data.settings.header_logo_desktop,
          uuid: data.settings.header_logo_text,
          preview: data.settings.header_logo_desktop,
        });
        form.setFields([
          { name: 'name', value: data.name },
          { name: 'subject', value: data.subject },
          { name: 'body', value: data.body },
          { name: 'footer_text', value: data.settings.footer_text },
          { name: 'platform', value: data.platform },
          { name: 'note', value: data.note || '' },
        ]);
        // Динамически создаем поля формы на основе data.data из бэка
        const dynamicFields = [{ name: 'to', value: '' }];

        if (data?.data) {
          Object.keys(data.data).forEach((key) => {
            const fieldData = data.data[key];
            dynamicFields.push({
              name: key,
              value: typeof fieldData === 'object' ? fieldData.value || '' : fieldData || '',
            });
          });
        }

        sendMailForm.setFields(dynamicFields);
        setSettings(data.settings);
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to fetch template',
        });
        closeModal();
      })
      .finally(() => {
        setEditLoading(false);
      });
  };

  useEffect(() => {
    if (isEdit && editId) {
      getEditData();
    }
  }, [isEdit, editId]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => closeModal()}
        title={isEdit ? 'Edit template' : 'Add new template'}
        maskClosable={false}
      >
        {editLoading ? (
          <div className={styles.formLoader}>
            <Loader />
          </div>
        ) : (
          <div className={styles.modalBody}>
            <Form className={styles.form} form={form} onFinish={submit}>
              <Form.Item name="name" rules={[{ required: true }]}>
                <Input label="Template name" style={{ width: '100%' }} />
              </Form.Item>

              <Form.Item name="subject" rules={[{ required: true }]}>
                <Input label="Header text" />
              </Form.Item>

              <Form.Item name="body" rules={[{ required: true }]}>
                <InputTextArea label="Greetings" />
              </Form.Item>

              <Form.Item name="footer_text">
                <InputTextArea label="Farewell" />
              </Form.Item>
              <Form.Item name="platform" rules={[{ required: true }]}>
                <Select
                  label="Select platform"
                  options={[
                    {
                      value: 'transparent',
                      label: (
                        <div className={styles.selectItem}>
                          <span>Transparent</span>
                        </div>
                      ),
                    },
                    {
                      value: 'shopping',
                      label: (
                        <div className={styles.selectItem}>
                          <span>Shopping</span>
                        </div>
                      ),
                    },
                    {
                      value: 'marketing',
                      label: (
                        <div className={styles.selectItem}>
                          <span>Marketing</span>
                        </div>
                      ),
                    },
                  ]}
                />
              </Form.Item>

              <Space className={styles.column} style={{ marginTop: '10px' }}>
                <b>Photo</b>

                <Space className={styles.column}>
                  <CheckBox
                    label="Use Current Profile Photo"
                    value={settings.header_logo_custom === '0'}
                    onChange={(value) =>
                      setSettings((prevValue) => ({
                        ...prevValue,
                        header_logo_custom: value.target.checked ? '0' : '1',
                      }))
                    }
                  />

                  <div>
                    <input
                      id="image-template-upload"
                      type="file"
                      hidden
                      style={{ visibility: 'hidden' }}
                      onChange={(e) => {
                        setImage(null);
                        setImageFile(null);
                        uploadImage(e.target.files[0]);
                      }}
                      accept={imageFileTypes}
                    />
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                    <label
                      htmlFor="image-template-upload"
                      style={{ width: '100%', display: 'block' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className={styles.dndCoverContent}>
                        {image ? (
                          <Space direction="vertical" style={{ width: '100%' }}>
                            <div className={styles.formImageWrapper}>
                              <Space style={{ alignItems: 'flex-start' }}>
                                <img
                                  src={image.preview}
                                  alt=""
                                  style={{
                                    height: '100%',
                                    width: '160px',
                                    objectFit: 'cover',
                                  }}
                                />

                                <div style={{ fontWeight: 500 }}>
                                  {image?.file?.name || image?.uuid || ''}
                                </div>
                              </Space>

                              <div>
                                <Space style={{ gap: 16 }}>
                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      document.getElementById('image-template-upload').click();
                                    }}
                                  >
                                    <ArrowReloadIcon style={{ width: 24, height: 24 }} />
                                  </div>

                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setImage(null);
                                      setImageFile(null);
                                    }}
                                  >
                                    <LitterBinIcon style={{ width: 24, height: 24 }} />
                                  </div>
                                </Space>
                              </div>
                            </div>

                            <CheckBox
                              label="Keep this photo unchanged from global updates"
                              value={settings.header_logo_default === '1'}
                              onChange={(value) =>
                                setSettings((prevValue) => ({
                                  ...prevValue,
                                  header_logo_default: value.target.checked ? '1' : '0',
                                }))
                              }
                            />
                          </Space>
                        ) : imageLoading ? (
                          <div className={styles.formImageLoader}>
                            <Loader />
                          </div>
                        ) : (
                          <>
                            <Button
                              type="link"
                              icon={
                                <AddIcon
                                  style={{ width: '20px', height: '20px' }}
                                  className="icon-blue-fill"
                                />
                              }
                              disabled={settings.header_logo_custom === '0'}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                document.getElementById('image-template-upload').click();
                              }}
                            >
                              Add image
                            </Button>
                          </>
                        )}
                      </div>
                    </label>
                  </div>
                </Space>
              </Space>

              <Space className={styles.column} style={{ marginTop: '10px' }}>
                <b>Customizing footer</b>

                <Collapse
                  items={footerSettings}
                  appearance="compact"
                  expandIcon={ExpandIcon}
                  className={styles.collapse}
                />
              </Space>

              <Form.Item name="note">
                <InputTextArea label="Note" rows={4} />
              </Form.Item>
            </Form>

            <Space className={styles.formRow} style={{ marginTop: '20px' }}>
              <Button type="default" style={{ width: '100%' }} onClick={closeModal}>
                Cancel
              </Button>

              <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
                {isEdit && editId && (
                  <>
                    <Button
                      type="default"
                      style={{ width: '100%' }}
                      onClick={() => setDeleteModalOpen(true)}
                    >
                      Delete
                    </Button>

                    <Button
                      type="default"
                      style={{ width: '100%' }}
                      onClick={openPreview}
                      loading={previewLoading}
                    >
                      Preview
                    </Button>
                    <Button type="default" style={{ width: '100%' }} onClick={sendTemplate}>
                      Send
                    </Button>
                  </>
                )}

                <Button
                  type="primary"
                  style={{ width: '100%' }}
                  onClick={() => form.submit()}
                  loading={loading}
                  disabled={imageLoading}
                >
                  {isEdit ? 'Update' : 'Save'}
                </Button>
              </Space>
            </Space>
          </div>
        )}
      </Modal>

      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        title="Do you really want to delete this template?"
      >
        <Space style={{ marginTop: '20px', justifyContent: 'space-between', width: '100%' }}>
          <Button type="default" onClick={() => setDeleteModalOpen(false)}>
            Cancel
          </Button>

          <Button type="primary" loading={deleteLoading} onClick={handleDeleteTemplate}>
            Delete
          </Button>
        </Space>
      </Modal>

      <Modal
        open={sendMailModalOpen}
        onClose={() => {
          setSendMailModalOpen(false);
        }}
        title="Send Email"
        maskClosable={false}
      >
        <div className={styles.modalBody}>
          <Form className={styles.form} form={sendMailForm} onFinish={handleSendMail}>
            <Form.Item
              name="to"
              rules={[
                { required: true, message: 'Email is required' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input label="Email (to)" style={{ width: '100%' }} />
            </Form.Item>

            {/* Динамически рендерим поля на основе editData.data */}
            {editData?.data &&
              Object.keys(editData.data).map((key) => {
                const fieldData = editData.data[key];
                const label =
                  typeof fieldData === 'object'
                    ? fieldData.label ||
                      key
                        .split('_')
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')
                    : key
                        .split('_')
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');

                return (
                  <Form.Item
                    key={key}
                    name={key}
                    rules={[{ required: true, message: `${label} is required` }]}
                  >
                    <Input label={label} style={{ width: '100%' }} />
                  </Form.Item>
                );
              })}

            <Space
              style={{
                marginTop: '20px',
                width: '100%',
                justifyContent: 'space-between',
                display: 'flex',
              }}
            >
              <Button
                type="default"
                style={{ width: '100%' }}
                onClick={() => {
                  setSendMailModalOpen(false);
                }}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                style={{ width: '100%' }}
                onClick={() => sendMailForm.submit()}
                loading={sendMailLoading}
              >
                Send
              </Button>
            </Space>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default TemplateModal;
